module.exports = __webpack_public_path__ + "img/spring_trip-20160416-5-1024x576.cc359811.jpg";